module.exports = __webpack_public_path__ + "static/media/06.3deaaa38.png";